<template>
  <el-table-column
    prop="type"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <el-tag
        v-if="scope.row.status === 'recorded'"
        size="small"
        type="info"
      >
        Rögzítve
      </el-tag>
      <el-tag
        v-if="scope.row.status === 'in-progress'"
        size="small"
        type="warning"
      >
        Folyamatban
      </el-tag>
      <el-tag
        v-if="scope.row.status === 'waiting'"
        size="small"
      >
        Várakozik a futásra
      </el-tag>
      <el-tag
        v-if="scope.row.status === 'done'"
        size="small"
        type="success"
      >
        Kész
      </el-tag>
      <el-tag
        v-if="scope.row.status === 'failed'"
        size="small"
        type="danger"
      >
        Hiba történt
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'type',
  };
</script>
